import { loadStripe, type Stripe } from '@stripe/stripe-js';

/* Stripe.js is loaded from js.stripe.com (never bundled). The platform instance sets cards up; a per-site instance confirms direct charges. */
const cache = new Map<string, Promise<Stripe | null>>();

export function platformStripe(pk: string): Promise<Stripe | null> {
  const k = `platform:${pk}`;
  if (!cache.has(k)) cache.set(k, loadStripe(pk));
  return cache.get(k)!;
}
export function siteStripe(pk: string, accountId: string): Promise<Stripe | null> {
  const k = `site:${pk}:${accountId}`;
  if (!cache.has(k)) cache.set(k, loadStripe(pk, { stripeAccount: accountId }));
  return cache.get(k)!;
}

export const stripeAppearance = () => ({
  theme: 'stripe' as const,
  variables: { colorPrimary: '#121110', colorBackground: '#ffffff', colorText: '#121110', borderRadius: '12px', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", Roboto, "Segoe UI", sans-serif' },
});
